import {
  Configuration,
  IPublicClientApplication,
  LogLevel,
  PublicClientApplication,
  RedirectRequest
} from '@azure/msal-browser';

// @ts-ignore
const process = { env: import.meta.env };

let basename = process.env.BASE_URL ? process.env.BASE_URL : '';
if (basename === '/') basename = '';
const port = window.location.port !== '' ? `:${window.location.port}` : '';
const uri = `${window.location.protocol}//${window.location.hostname}${port}${basename}`;
const tenantId = '079ab1aa-0b18-4ba5-98b5-cbc6e750232a';

/**
 * The MSAL scopes object for Prism API authentication, requesting the user_impersonation scope to act on behalf of the authenticated user.
 */
export const prismScopes = {
  scopes: [
    // 'api://f3631d68-5c1c-4bbb-aa2f-aa6c8e25d553'
    'api://1cea8ce4-5aa3-4d88-b63f-2bd344ea6d25/user_impersonation'
    // 'api://f3631d68-5c1c-4bbb-aa2f-aa6c8e25d553/user_impersonation'
  ]
};
//http://localhost:5173/callback#error=invalid_resource&error_description=AADSTS500011%3a+The+resource+principal+named+api%3a%2f%2f11111111-1111-1111-1111-111111111111+was+not+found+in+the+tenant+named+079ab1aa-0b18-4ba5-98b5-cbc6e750232a.+This+can+happen+if+the+application+has+not+been+installed+by+the+administrator+of+the+tenant+or+consented+to+by+any+user+in+the+tenant.+You+might+have+sent+your+authentication+request+to+the+wrong+tenant.+Trace+ID%3a+df7378df-5e91-417a-a320-de1a7b2c0902+Correlation+ID%3a+069605d8-4e73-49e8-b0eb-1a70bc8c22c7+Timestamp%3a+2023-11-28+02%3a52%3a20Z&error_uri=https%3a%2f%2flogin.microsoftonline.com%2ferror%3fcode%3d500011&state=eyJpZCI6ImViYzMxOGM3LWQ2M2UtNDgyNi04YTVmLTM0MDVmYzgxZjNkNSIsIm1ldGEiOnsiaW50ZXJhY3Rpb25UeXBlIjoicmVkaXJlY3QifX0%3d

/**
 * A set of MSAL scopes for acquiring a basic OpenID Connect token (profile, email, offline_access) without targeting any specific API's user_impersonation scope.
 */
export const silentRequestScopes = {
  scopes: [
    'openid',
    'profile',
    'email',
    'offline_access',
    'user.readbasic.all',
    'user.readwrite ',
    'people.read',
    'presence.read.all'
  ]
};
/**
 * The MSAL redirect request that initiates the login flow, requesting OpenID Connect scopes plus user.readbasic.all and presence.read.all.
 */
export const loginRequest: RedirectRequest = {
  scopes: [
    'openid',
    'profile',
    'email',
    'offline_access',
    'user.readbasic.all',
    'user.readwrite ',
    'people.read',
    'presence.read.all'
  ],
  extraScopesToConsent: []
};

/**
 * Creates an MSAL PublicClientApplication configured with the current app's redirect URI, the tenant ID, and a 20-minute token renewal offset. Accepts an optional additionalConfig spread for overrides.
 */
export const createMsalInstance = (
  clientId: string,
  additionalConfig: any = {}
): IPublicClientApplication => {
  const authConfig: Configuration = {
    auth: {
      clientId,
      knownAuthorities: ['https://login.microsoftonline.com'],
      authority: `https://login.microsoftonline.com/${tenantId}`,
      redirectUri: `${uri}/callback`,
      navigateToLoginRequestUrl: true,
      postLogoutRedirectUri: `${uri}/`
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false
    },
    system: {
      tokenRenewalOffsetSeconds: 1200,
      loggerOptions: {
        logLevel: 0,
        loggerCallback: (level: any, message: string, containsPii: boolean) => {
          if (containsPii) {
            return;
          }
          switch (level) {
            case LogLevel.Error:
              console.error(message);
              return;
            case LogLevel.Info:
              console.info(message);
              return;
            case LogLevel.Verbose:
              console.debug(message);
              return;
            case LogLevel.Warning:
              console.warn(message);
          }
        }
      }
    },
    ...additionalConfig
  };
  return new PublicClientApplication(authConfig);
};
